<template>
    <div>
        <van-overlay :show="show" :z-index="102">
            <div class="wrap">
                <div class="login">
                    <h4>请登录后再购买</h4>
                    <div class="form">
                        <div class="form-item">
                            <img class="form-item__icon" src="@/assets/vipCoach/v2/icon_sj.png" />
                            <input v-model.trim="formCode.phone" class="form-item__input" placeholder="请输入手机号码" type="number" pattern="[0-9]*" @input="() => {formCode.phone.length >11 && (formCode.phone = formCode.phone.slice(0,11))}">
                        </div>
                        <div class="form-item">
                            <img class="form-item__icon" src="@/assets/vipCoach/v2/icon_txyzm.png" />
                            <input v-model.trim="formCode.imgCode" class="form-item__input" placeholder="请输入图形验证码" type="number" pattern="[0-9]*" @input="() => {formCode.imgCode.length >4 && (formCode.imgCode = formCode.imgCode.slice(0,4))}">
                            <img class="form-item__code" :src="imageCode" />
                            <img class="form-item__reset" src="@/assets/vipCoach/v2/icon_sx01.png" @click="getPhotoCode" />
                        </div>
                        <div class="form-item">
                            <img class="form-item__icon" src="@/assets/vipCoach/v2/icon_yzm.png" />
                            <input v-model.trim="formData.shortMessageCode" class="form-item__input" type="number" pattern="[0-9]*" placeholder="请输入验证码" @input="() => {formData.shortMessageCode.length >6 && (formData.shortMessageCode = formData.shortMessageCode.slice(0,6))}">
                            <div class="form-item__btn" :class="{ disabled: !!codeTime }" @click="handleGetCode">{{codeTime === 0 ?'获取验证码':`已获取${codeTime}s`}}</div>
                        </div>
                        <van-button class="custom-btn" color="#53CB85" round block @click="handleLogin">立即登录</van-button>
                        <p class="agreement">登录即表示你已阅读并同意<a @click="agreementStatus = true">《用户隐私协议》</a></p>
                        <p class="tips">* 购买后请使用该手机号登录斑斑驾道定制版 APP查看对应商品并使用相关功能。</p>
                    </div>
                </div>
                <img class="btn-close" src="@/assets/vipCoach/v2/icon_gb.png" @click="handleCloseLogin" />
            </div>
        </van-overlay>
        <van-action-sheet v-model="agreementStatus" title="用户隐私协议" teleport="body">
            <div class="agreement-content">
                <agreement type="1" />
            </div>
        </van-action-sheet>
    </div>
</template>
<script>
import { Toast, Overlay, Button, ActionSheet } from 'vant'
import agreement from '../../components/agreement.vue'
let timer = null
export default {
    name: 'goodsLogin',
    components: {
        [Overlay.name]: Overlay,
        [Button.name]: Button,
        [ActionSheet.name]: ActionSheet,
        agreement
    },
    props: {
        appid: {
            type: String,
            default: ''
        }
    },
    data () {
        return {
            agreementStatus: false,
            show: false,
            imageCode: '',
            // 获取验证码表单
            formCode: {
                imgCode: '',
                loginType: 'student',
                openId: '',
                phone: '',
                uuid: ''
            },
            // 登录表单
            formData: {
                loginType: 'student',
                phone: '',
                openId: '',
                shortMessageCode: ''
            },
            // 获取验证码倒计时态
            codeTime: 0
        }
    },
    computed: {
        wxUserInfo () {
            return 
        }
    },
    methods: {
        // 获取图形验证码
        getPhotoCode () {
            this.$api.getCoachPhotoCode({
                width: 100,
                height: 50
            }).then(res => {
                if (res.status) {
                    const { uuid, image } = res.result
                    this.formCode.uuid = uuid
                    this.imageCode = image
                }
            })
        },
        // 获取验证码
        handleGetCode () {
            if (this.codeTime !== 0) {
                return
            }
            if (!/^1\d{10}$/.test(this.formCode.phone)) { // 校验手机号是否合法
                Toast.fail('请输入有效的手机号码')
            } else if (!this.formCode.imgCode) { // 校验验证码是否合法
                Toast.fail('图形验证码不能为空')
            } else {
                Toast.loading({ duration: 0, forbidClick: true })
                this.$api.getCoachStudentLoginCode(this.formCode).then(res => {
                    Toast.clear()
                    if (res.status) {
                        Toast.success('验证码已发送')
                        // 开启定时器 控制是否点击验证码
                        this.codeTime = 60
                        timer = setInterval(() => {
                            --this.codeTime
                            if (this.codeTime === 0) {
                                clearInterval(timer)
                            }
                        }, 1000)
                    } else {
                        this.getPhotoCode()
                        Toast.fail(res.message)
                    }
                }).catch(() => {
                    Toast.clear()
                })
            }
        },
        // 立即登录
        handleLogin () {
            if (!/^1\d{10}$/.test(this.formCode.phone)) { // 校验手机号是否合法
                Toast.fail('请输入有效的手机号码')
            } else if (!this.formData.shortMessageCode) { // 校验验证码是否合法
                Toast.fail('短信验证码不能为空')
            } else {
                Toast.loading({ duration: 0, forbidClick: true })
                this.formData.phone = this.formCode.phone
                this.$api.getCoachStudentLogin(this.formData).then(res => {
                    Toast.clear()
                    if (res.status) {
                        this.show = false
                        // 设置phone token
                        this.$store.dispatch('vipCoach/setWxPhone', {
                            phone: this.formData.phone,
                            token: res.result
                        })
                        Toast.success('登录成功')
                        // 登录成功后重新加载
                        setTimeout(() => {
                            location.reload()
                        }, 500)
                        // 登录成功 通知父组件操作
                        // this.$emit('loginSuccess')
                        // this.handleCloseLogin()
                    } else {
                        Toast.fail(res.message)
                    }
                }).catch(() => {
                    Toast.clear()
                })
            }
        },
        // 关闭登录弹窗
        handleCloseLogin () {
            this.show = false
            setTimeout(() => {
                this.$emit('closed')
            }, 500)
        }
    },
    mounted () {
        this.show = true
        const openId = this.$store.getters['vipCoach/wxUser'].openId
        this.formCode.openId = openId
        this.formData.openId = openId
        this.getPhotoCode()
    },
    destroyed () {
        clearInterval(timer)
    }
}
</script>
<style lang="scss" scoped>
*{
    box-sizing: border-box;
}
.wrap{
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .btn-close{
        display: block;
        margin:0 auto;
        margin-top: 30px;
        width: 35px;
    }
}
.login{
    padding: 20px;
    width: 310px;
    background-color: #fff;
    border-radius: 5px;
    color:#333;
    font-size: 13px;
    line-height: 1;
    h4{
        font-size: 18px;
        font-weight: 500;
        text-align: center;
    }
    .form{
        &-item{
            display: flex;
            align-items: center;
            padding-bottom: 12px;
            margin-top: 24px;
            border-bottom: 1px solid #ccc;
            &__icon{
                margin-right: 10px;
                width: 24px;
                height: 24px;
            }
            &__input{
                width: 0;
                flex: 1;
                border: 0;
            }
            &__code{
                width: 54px;
                border:1px solid #eee;
                border-radius: 2px;
                overflow: hidden;
            }
            &__reset{
                margin-left: 7px;
                width: 18px;
                height: 18px;
            }
            &__btn{
                flex: 0 0 100px;
                height: 30px;
                line-height: 30px;
                color: #53CB85;
                border-radius: 5px;
                text-align: center;
                border: 1px solid #53CB85;
                &.disabled{
                    color:#aaa;
                    border-color: #aaa;
                }
            }
        }
    }
    .custom-btn{
        margin-top: 25px;
        font-size: 17px;
    }
    .agreement{
        margin-top: 20px;
        line-height: 16px;
        a{
            color: #53CB85;
        }
    }
    .tips{
        margin-top: 20px;
        color: #FF5050;
        line-height: 20px;
    }
}
</style>
